import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import List from 'src/components/grid.component';
import { CreatedDateColumnHandler, StatusColumnHandler } from './service';

const CardHistory = (props) => {
  const gridRef = React.createRef();
  let { id } = useParams();
  const apiTransactionUrl = process.env.REACT_APP_GRID_API + `api/KycService/Cards/CardHistory/${id}/${props?.cardName}`;


  const dateColumnHandler = (props) => { return (<CreatedDateColumnHandler data={props} />) }
  const statusColumnHandler = (props) => { return (<StatusColumnHandler data={props} />) }

  const customcells = {
    "createdDate": dateColumnHandler,
    "action": statusColumnHandler,
  };

  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [])

  return (
    <>
      <p className='text-titleColor font-semibold text-2xl  mb-2 mt-4 '>Card Activity</p>
      <List
        showExcelExport={true}
        url={apiTransactionUrl}
        ref={gridRef}
        pSize={10}
        className="custom-grid grid-alignment"
        pKey={"Transactions"}
        sortable={true}
        screenName={'Customer_Card_History'}
        renderCustomCell={renderCustomCell}
        showDisplayColumns={false}
      />
    </>
  );
};
const connectStateToProps = ({ userConfig, oidc }) => {
  return { userConfig: userConfig?.userProfileInfo, user: oidc?.user }
}
export default connect(connectStateToProps)(CardHistory);
